package de.connect2x.timmy

import kotlinx.browser.document
import org.w3c.dom.HTMLLinkElement
import org.w3c.dom.asList

fun setFavicon(iconUrl: String) {
    // Remove existing favicons (important for Chrome)
    document.querySelectorAll("link[rel*='icon']").asList().forEach {
        it.parentNode?.removeChild(it)
    }

    val link = document.createElement("link") as HTMLLinkElement
    link.rel = "icon"
    link.type = "image/x-icon"
    link.href = iconUrl

    document.head?.appendChild(link)
}

fun setTitle(appName: String) {
    document.title = appName
}
